import { useContext } from 'react'

import { PassContext } from "../../../pass-context"

export default () => {

  const { template } = useContext(PassContext)

  if (template.meta.appLink) return (
    <img src={template.meta.appLink.icon} className="app-link-logo" />
  )
}